var _this = this;
import * as tslib_1 from "tslib";
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { PerformanceDatapoint } from 'owa-analytics';
import { getMasterCategoryList } from 'owa-categories';
import { getGuid } from 'owa-guid';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { orchestrator } from 'satcheljs';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import outlookFavoritePersonasLoaded from '../actions/v2/people/outlookFavoritePersonasLoaded';
import { isCategoryInFavorites, migrateOutlookFavorites, getIsBitEnabled, parseFavoriteNode, setFavoriteBitFlag, createMultipleOutlookFavoritesService, createClientFavoriteCategoryData, createOwsFavoriteCategoryData, isPersonaInFavorites, lazyAddMultipleFavoritesCompleted, lazyAddMultipleFavoritesToStore, convertServiceResponseToFavoriteData, } from 'owa-favorites';
import { createOwsFavoritePersonaData, createClientFavoritePersonaData, } from '../utils/favoritePersonaDataHelper';
var MAX_NUMBER_OF_FAVORITES_PER_REQUEST = 20;
export default orchestrator(migrateOutlookFavorites, function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var rawFavoritesNodes, favoritesDataToMigrate, owsFavoritesToMigrate, clientFavoritesData, addMultipleFavoritesToStore, personasToMigrate, numberOfRequests, hasFailureDuringMigration, migrationServiceDatapoint, i, index, batchedOwsFavoritesData, migrationSingleBatchServiceDatapoint, batchTempData, isFirstAttemptToMigrate, migrationCompletedDatapoint;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                rawFavoritesNodes = getUserConfiguration().UserOptions.FavoriteNodes;
                favoritesDataToMigrate = getFavoritesDataToMigrate(rawFavoritesNodes);
                owsFavoritesToMigrate = favoritesDataToMigrate.owsFavoritesData;
                clientFavoritesData = favoritesDataToMigrate.clientFavoritesData;
                if (owsFavoritesToMigrate.length === 0) {
                    // Mark the migration completed if there is no favorite to migrate
                    markMigrationCompleted();
                    return [2 /*return*/];
                }
                return [4 /*yield*/, lazyAddMultipleFavoritesToStore.import()];
            case 1:
                addMultipleFavoritesToStore = _a.sent();
                addMultipleFavoritesToStore(clientFavoritesData);
                personasToMigrate = clientFavoritesData.filter(function (favorite) { return favorite.type === 'persona'; });
                if (personasToMigrate.length > 0) {
                    // 3.1. Fire another outlookFavoritesLoaded action to check the existence of search folders for the new favorite personas
                    outlookFavoritePersonasLoaded(personasToMigrate);
                }
                numberOfRequests = Math.ceil(owsFavoritesToMigrate.length / MAX_NUMBER_OF_FAVORITES_PER_REQUEST);
                hasFailureDuringMigration = false;
                migrationServiceDatapoint = new PerformanceDatapoint(datapoints.MigrateOutlookFavoriteService.datapoint.name, datapoints.MigrateOutlookFavoriteService.datapoint.options);
                migrationServiceDatapoint.addCustomProperty('totalBatchCount', numberOfRequests);
                i = 0, index = 0;
                _a.label = 2;
            case 2:
                if (!(i < numberOfRequests)) return [3 /*break*/, 5];
                batchedOwsFavoritesData = owsFavoritesToMigrate.slice(index, index + MAX_NUMBER_OF_FAVORITES_PER_REQUEST);
                migrationSingleBatchServiceDatapoint = new PerformanceDatapoint(datapoints.MigrateOutlookFavoriteSingleBatchService.datapoint.name, datapoints.MigrateOutlookFavoriteSingleBatchService.datapoint.options);
                // Log the number of total favorites to be migrated
                migrationSingleBatchServiceDatapoint.addCustomProperty('favoritesCount', batchedOwsFavoritesData.length);
                batchTempData = clientFavoritesData.slice(index, index + MAX_NUMBER_OF_FAVORITES_PER_REQUEST);
                return [4 /*yield*/, makeMigrationRequestAndProcessResult(batchedOwsFavoritesData, batchTempData, migrationSingleBatchServiceDatapoint)];
            case 3:
                hasFailureDuringMigration = _a.sent();
                _a.label = 4;
            case 4:
                i++, index += MAX_NUMBER_OF_FAVORITES_PER_REQUEST;
                return [3 /*break*/, 2];
            case 5:
                // 5. End logging datapoints to track the total time of migration service requests
                if (hasFailureDuringMigration) {
                    migrationServiceDatapoint.endWithError("ServerError" /* ServerError */);
                }
                else {
                    migrationServiceDatapoint.end();
                }
                isFirstAttemptToMigrate = !getIsBitEnabled(8 /* RoamingFavoritesMigrationFirstAttemptDone */);
                if (isFirstAttemptToMigrate) {
                    markFirstAttemptMigrationDone();
                    if (!hasFailureDuringMigration) {
                        // Mark user as migrated if 1st attempt succeeds
                        markMigrationCompleted();
                    }
                }
                else {
                    // Force as migration completed if it is the 2nd attempt
                    markMigrationCompleted();
                }
                migrationCompletedDatapoint = isFirstAttemptToMigrate
                    ? datapoints.FirstAttemptMigrationCompleted.datapoint
                    : datapoints.SecondAttemptMigrationCompleted.datapoint;
                logUsage(migrationCompletedDatapoint.name, migrationCompletedDatapoint.customData(hasFailureDuringMigration), null, migrationCompletedDatapoint.options);
                return [2 /*return*/];
        }
    });
}); });
/**
 * Perform a createMultiple request with favorites to migrate, add the results to store if successful
 * @param batchedOwsFavoritesData The Service data to be sent to Prime
 * @param batchTempData The temp data added to the store
 * @param migrationSingleBatchServiceDatapoint The migration datapoint for this batch
 * @returns A boolean indicating whether a migration error occurred
 */
function makeMigrationRequestAndProcessResult(batchedOwsFavoritesData, batchTempData, migrationSingleBatchServiceDatapoint) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, e_1, convertedResponses, addMultipleFavoritesCompleted, migratedPersonas, migratedCategories, e_2;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, createMultipleOutlookFavoritesService(batchedOwsFavoritesData)];
                case 1:
                    response = _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    // Log a server error if it occurred
                    migrationSingleBatchServiceDatapoint.endWithError("ServerError" /* ServerError */, e_1);
                    return [2 /*return*/, true];
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    convertedResponses = (response.value || []).map(function (favorite) {
                        return convertServiceResponseToFavoriteData(favorite, favorite.Type.toLowerCase());
                    });
                    return [4 /*yield*/, lazyAddMultipleFavoritesCompleted.import()];
                case 4:
                    addMultipleFavoritesCompleted = _a.sent();
                    // Add favorites to the store
                    addMultipleFavoritesCompleted(batchTempData, convertedResponses);
                    migratedPersonas = convertedResponses.filter(function (favorite) { return favorite.type === 'persona'; });
                    migratedCategories = convertedResponses.filter(function (favorite) { return favorite.type === 'category'; });
                    migrationSingleBatchServiceDatapoint.addCustomProperty('migratedPersonasCount', migratedPersonas.length);
                    migrationSingleBatchServiceDatapoint.addCustomProperty('migratedCategoriesCount', migratedCategories.length);
                    // End logging datapoint to track the time for a single migration service call
                    migrationSingleBatchServiceDatapoint.end();
                    return [3 /*break*/, 6];
                case 5:
                    e_2 = _a.sent();
                    // Log a client error if it occurred
                    migrationSingleBatchServiceDatapoint.endWithError("ClientError" /* ClientError */, e_2);
                    return [2 /*return*/, true];
                case 6: return [2 /*return*/, false];
            }
        });
    });
}
/**
 * Get the favorites data to migrate as two lists
 * @param rawFavoritesNodes the favorite nodes data in UserOptions
 * @return two lists which represents the service favorites data list and client favorites data list to be migrated
 */
function getFavoritesDataToMigrate(rawFavoritesNodes) {
    if (!rawFavoritesNodes) {
        return { owsFavoritesData: [], clientFavoritesData: [] };
    }
    // Convert each raw favorite node to service type and client type
    var owsFavoritesDataList = [];
    var clientFavoritesDataList = [];
    rawFavoritesNodes.forEach(function (rawNode) {
        var parsedNode = parseFavoriteNode(rawNode);
        switch (parsedNode.type) {
            case 1 /* Persona */:
                var personaNode = parsedNode;
                if (!isPersonaInFavorites(personaNode.personaId, personaNode.mainEmailAddress)) {
                    var temporaryGuid = getGuid();
                    var clientFavoritePersonaData = createClientFavoritePersonaData(temporaryGuid, personaNode, true /* isMigration */);
                    var owsFavoritePersonaData = createOwsFavoritePersonaData(personaNode);
                    owsFavoritesDataList.push(owsFavoritePersonaData);
                    clientFavoritesDataList.push(clientFavoritePersonaData);
                }
                break;
            case 4 /* Category */:
                var categoryIdToMigrate_1 = parsedNode.id;
                var category = getMasterCategoryList().filter(function (category) { return category.Id === categoryIdToMigrate_1; })[0];
                // Migrate the category only if
                // - it is still a valid category because user might already deleted this category from other client
                // - category hasn't been favorited in SDS
                if (category && !isCategoryInFavorites(categoryIdToMigrate_1)) {
                    var temporaryGuid = getGuid();
                    var clientFavoriteCategoryData = createClientFavoriteCategoryData(temporaryGuid, category, true /* isMigration */);
                    var owsFavoriteCategoryData = createOwsFavoriteCategoryData(category, true /* isMigration */);
                    owsFavoritesDataList.push(owsFavoriteCategoryData);
                    clientFavoritesDataList.push(clientFavoriteCategoryData);
                }
                break;
            default:
                // No need to migrate other type of favorites
                break;
        }
    });
    // Only add the favorite data to migration list if it is not present in SDS
    return { owsFavoritesData: owsFavoritesDataList, clientFavoritesData: clientFavoritesDataList };
}
/**
 * Mark the user as migrate completed
 */
function markMigrationCompleted() {
    markFavoritesMigrationBitInternal(16 /* RoamingFavoritesMigrationCompleted */);
}
/**
 * Mark the bit to indicate the fist attempt to migrate outlook favorites has been done
 */
function markFirstAttemptMigrationDone() {
    markFavoritesMigrationBitInternal(8 /* RoamingFavoritesMigrationFirstAttemptDone */);
}
/**
 * Mark the bit value as 1 given the bit mask
 * @param mask of the favorite bit
 */
function markFavoritesMigrationBitInternal(mask) {
    setFavoriteBitFlag(true /* value*/, mask);
    // Send out request to update both UserOptions.FavoriteNodes and FavoritesBitFlags
    var userOptions = getUserConfiguration().UserOptions;
    updateUserConfiguration('OWA.UserOptions', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['FavoritesBitFlags'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'Integer32',
                Value: ["" + userOptions.FavoritesBitFlags],
            }),
        }),
    ]);
}
//# sourceMappingURL=migrateOutlookFavoritesOrchestrator.js.map